import React from 'react';
import { connect } from 'react-redux';
import { closePanel } from '../../Redux/Panels/RightPanel/actions';
import Dashboard from '../doctor/secure/Dashboard';
import PatientDashboard from '../patient/Dashboard';

const DashboardSwitcher = (props) => {
    if(props?.user?.role === "PATIENT"){
        return <PatientDashboard />
    }
    return <Dashboard/>
}


const mapStateToProps = (state) => {
	return { user: state.user.user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSwitcher);
